import Section from './section';
import PaymentTerms from './payment-terms';
import Contract from './contract';
const AdvanceBreakdown = {
  Section,
  PaymentTerms,
  Contract
};
export default AdvanceBreakdown;
//# sourceMappingURL=index.js.map